import { h, type FunctionalComponent } from 'vue'
import { NuxtLink } from '#components'

// Functional: the amber dot and wordmark, used in the app nav, the auth pages, the
// landing page and the error page. Styles are the .brand rules in assets/css/main.css.
const AppBrand: FunctionalComponent<{ to?: string }> = (props) =>
  h(NuxtLink, { to: props.to ?? '/', class: 'brand', 'aria-label': 'BetterBlast home' }, () => [
    h('span', { class: 'brand-dot' }),
    h('span', { class: 'brand-word display' }, 'betterblast'),
  ])

AppBrand.props = ['to']

export default AppBrand
